export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-select.fa569648.svg","height":16,"width":185};